import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-white mb-4">天美麻花星空影视</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              超清蓝光电视剧全集、电影大全不缓冲免费在线观看，大屏TV版最新综艺动漫免费看。致力于为您提供最优质的影视观看体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">影视分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">联系我们</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">特色服务</h4>
            <ul className="flex flex-col gap-2 text-sm text-foreground-400">
              <li>超清蓝光画质</li>
              <li>不缓冲流畅播放</li>
              <li>大屏TV版支持</li>
              <li>免费在线观看</li>
              <li>每日更新片源</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 天美麻花星空影视 版权所有 | 免费在线影视平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}